import { Header as CoreHeader, Nav } from "@babylonlabs-io/core-ui";
import { useWalletConnect } from "@babylonlabs-io/wallet-connector";
import { NavLink } from "react-router";
import { twJoin } from "tailwind-merge";

import { useAppState } from "@/ui/common/state";

import { Connect } from "../Wallet/Connect";
import { SnowFallComboLogo } from "../SnowFall/SnowFallComboLogo";

export const Header = () => {
  const { open } = useWalletConnect();
  const { isLoading: loading } = useAppState();

  const navItems = [
    { title: "BTC Staking", to: "/btc" },
    { title: "BABY Staking", to: "/baby" },
    { title: "Rewards", to: "/rewards" },
  ];

  const navigation = (
    <div className="snowfall-nav">
      <Nav>
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              twJoin(
                "flex h-10 w-fit items-center justify-center whitespace-nowrap text-center",
                "snowfall-nav-link",
                isActive ? "snowfall-nav-link-active" : "",
              )
            }
          >
            {item.title}
          </NavLink>
        ))}
      </Nav>
    </div>
  );

  const mobileNavigation = (
    <>
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            twJoin(
              "flex h-10 w-fit items-center justify-center whitespace-nowrap text-center",
              "snowfall-nav-link",
              isActive ? "snowfall-nav-link-active" : "",
            )
          }
        >
          {item.title}
        </NavLink>
      ))}
    </>
  );

  return (
    <CoreHeader
      className="snowfall-header sticky top-0 z-40 mb-10 md:mb-14"
      size="sm"
      navigation={navigation}
      mobileNavigation={mobileNavigation}
      logo={
        <NavLink to="/btc" aria-label="Snow Fall staking home">
          <SnowFallComboLogo />
        </NavLink>
      }
      mobileLogo={
        <NavLink to="/btc" aria-label="Snow Fall staking home">
          <SnowFallComboLogo size="sm" />
        </NavLink>
      }
      rightActions={<Connect loading={loading} onConnect={open} />}
    />
  );
};
